import { GoogleGenAI } from "@google/genai";
const GEMINI_API_KEY = import.meta.env.VITE_GEMINI_API_KEY;

export async function summarizeTranscript(transcript) {

    const ai = new GoogleGenAI({ apiKey: GEMINI_API_KEY });
    
    const response = await ai.models.generateContent({
        model: "gemini-2.0-flash",
        contents: `Summarize the following meetup discussion transcript in Markdown such that it looks appealing and has proper headers and content broken down into notable topics which can then be rendered back by the react-markdown library, hence only provide the markdown code without the "markdown" mentioned in the code:\n\n${transcript}`,
    });

    // if (!response.ok) {
    //     throw new Error('Failed to fetch summary');
    // }

    return response.text;
}
